import {singleton} from "tsyringe";
import {persistence} from "../../decorators/persistence.decorator";
import {Repository} from "../../persistence/repository";
import {Keyword} from "../entities/keyword.entity";

@singleton()
@persistence({
    entity: Keyword
})
export class KeywordRepository extends Repository<Keyword> {

    public create(): Promise<Keyword | null> {
        return Promise.resolve(new Keyword());
    }
}